<div class="toggle-content">
  <label class="toggle-switch text">
    <input
      type="checkbox"
      [name]="name"
      [disabled]="disabled"
      [value]="value"
      [checked]="checked"
      (change)="onToggleChange($event)"
    />
    <span class="slider"></span>
  </label>
  <div class="text-content" *ngIf="label">
    <span class="label" [class.label-disabled]="disabled">{{ label }}</span>
  </div>
</div>
